// src/pages/inventory/rimender-stock/RimenderStockTableHead.jsx
import React from "react";
import { TableHead, TableCell, TableRow } from "@mui/material";

// Helper function untuk mendapatkan bulan berikutnya
const getNextMonth = (monthYearStr, monthsToAdd) => {
    if (!monthYearStr) return "";
    
    // Parse month and year from format "MMM-YY" (e.g., "Feb-26")
    const parts = monthYearStr.split('-');
    if (parts.length !== 2) return "";
    
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const currentMonthIndex = monthNames.findIndex(m => m === parts[0]);
    if (currentMonthIndex === -1) return "";
    
    const currentYear = parseInt(parts[1]);
    
    // Calculate new month and year
    let newMonthIndex = currentMonthIndex + monthsToAdd;
    let newYear = currentYear;
    
    while (newMonthIndex >= 12) {
        newMonthIndex -= 12;
        newYear += 1;
    }
    
    // Format new year to 2 digits
    const newYearStr = newYear.toString().padStart(2, '0');
    
    return `${monthNames[newMonthIndex]}-${newYearStr}`;
};

function RimenderStockTableHead({ forecastHeader, actualHeader }) {
    return (
        <TableHead>
            {/* Header 1 */}
            <TableRow className="tr">
                {/* Group */}
                <TableCell className="ded-tch" rowSpan={3}>
                    Group
                </TableCell>

                {/* Item Code */}
                <TableCell className="ded-tch" rowSpan={3}>
                    Item Code
                </TableCell>

                {/* Description */}
                <TableCell className="ded-tch" rowSpan={3}>
                    Description
                </TableCell>

                {/* UoM */}
                <TableCell className="ded-tch" rowSpan={3}>
                    UoM
                </TableCell>

                {/* Fresh Pineapple */}
                <TableCell className="ded-tch" colSpan={10} align="center">
                    Fresh Pineapple
                </TableCell>

                {/* Banana */}
                <TableCell className="ded-tch" colSpan={10} align="center">
                    Banana
                </TableCell>

                {/* Other Fresh Fruits */}
                <TableCell className="ded-tch" colSpan={7} align="center">
                    Other Fresh Fruits
                </TableCell>

                {/* Total Forecast PG4 */}
                <TableCell className="ded-tch" colSpan={4} align="center">
                    Total Forecast PG4 
                </TableCell>

                {/* Stock PG4 */}
                <TableCell className="ded-tch" colSpan={7} align="center">
                    Stock PG4
                </TableCell>

                {/* Status Stock terhadap Fc M1 */}
                <TableCell className="ded-tch" rowSpan={3} align="center">
                    Status Stock<br/>terhadap Fc ({forecastHeader})
                </TableCell>

                {/* Safety Stock */}
                {/*
                <TableCell className="ded-tch" rowSpan={3} align="center">
                    Safety Stock
                </TableCell>
                */}

                {/* Estimasi Kekurangan Stock Bulan Berjalan (M1) */}
                <TableCell className="ded-tch" rowSpan={3} align="center">
                    Estimasi Kekurangan<br/>Stock Bulan Berjalan ({forecastHeader})
                </TableCell>

                {/* Estimasi Kekurangan Stock terhadap Forecast (M2) */}
                <TableCell className="ded-tch" rowSpan={3} align="center">
                    Estimasi Kekurangan<br/>Stock terhadap Forecast ({getNextMonth(forecastHeader, 1)})
                </TableCell>

                {/* Estimasi Kekurangan Stock terhadap Forecast (M3) */}
                <TableCell className="ded-tch" rowSpan={3} align="center">
                    Estimasi Kekurangan<br/>Stock terhadap Forecast ({getNextMonth(forecastHeader, 2)})
                </TableCell>
            </TableRow>

            {/* Header 2 */}
            <TableRow className="tr">
                {/* Fresh Pineapple - Forecast */}
                <TableCell colSpan={7} className="ded-tc" align="center">
                    <div>Forecast</div>
                </TableCell>

                {/* Fresh Pineapple - Actual */}
                <TableCell colSpan={3} className="ded-tc" align="center">
                    <div>Actual</div>
                </TableCell>
                
                {/* Banana - Forecast */}
                <TableCell colSpan={7} className="ded-tc" align="center">
                    <div>Forecast</div>
                </TableCell>

                {/* Banana - Actual */}
                <TableCell colSpan={3} className="ded-tc" align="center">
                    <div>Actual</div>
                </TableCell>

                {/* Other Fresh Fruits - Forecast */}
                <TableCell colSpan={4} className="ded-tc" align="center">
                    <div>Forecast</div>
                </TableCell>

                {/* Other Fresh Fruits - Actual */}
                <TableCell colSpan={3} className="ded-tc" align="center">
                    <div>Actual</div>
                </TableCell>

                {/* Total Forecast PG4 - Total Forecast */}
                <TableCell className="ded-tc" rowSpan={2} align="center">
                    Total Forecast ({forecastHeader})
                </TableCell>

                {/* Total Forecast PG4 - Total Realisasi */}
                <TableCell className="ded-tc" rowSpan={2} align="center">
                    Total Realisasi ({forecastHeader})
                </TableCell>

                {/* Total Forecast PG4 - FC Berjalan */}
                <TableCell className="ded-tc" rowSpan={2} align="center">
                    FC Berjalan
                </TableCell>

                {/* Total Forecast PG4 - Kekurangan terhadap Stock */}
                <TableCell className="ded-tc" rowSpan={2} align="center">
                    Kekurangan terhadap Stock
                </TableCell>

                {/* Stock PG4 - Warehouse BPP */}
                <TableCell rowSpan={2} className="ded-tc" align="center">Warehouse<br/>BPP</TableCell>

                {/* Stock PG4 - Gd. Mixer Fresh Pine */}
                <TableCell rowSpan={2} className="ded-tc" align="center">Gd. Mixer<br/>Fresh Pine</TableCell>

                {/* Stock PG4 - Gd. Mat. Banana */}
                <TableCell rowSpan={2} className="ded-tc" align="center">Gd. Mat.<br/>Banana</TableCell>

                {/* Stock PG4 - Gd. Mat. Other Fruits */}
                <TableCell rowSpan={2} className="ded-tc" align="center">Gd. Mat.<br/>Other Fruits</TableCell>

                {/* Stock PG4 - Quality Insp */}
                <TableCell rowSpan={2} className="ded-tc" align="center">Quality<br/>Insp</TableCell>

                {/* Stock PG4 - Transit and Transfer */}
                <TableCell rowSpan={2} className="ded-tc" align="center">Transit and<br/>Transfer</TableCell>

                {/* Stock PG4 - Total Stock PG4 */}
                <TableCell rowSpan={2} className="ded-tc" align="center">Total<br/>Stock PG4</TableCell>
            </TableRow>

            {/* Header 3 */}
            <TableRow className="tr">
                {/* Fresh Pineapple - Forecast (M1) */}
                <TableCell className="ded-tc" align="center" sx={{top:'96px!important'}}>
                    <div style={{ fontSize: "0.85em", fontWeight: "normal" }}>
                        ({forecastHeader})
                    </div>
                </TableCell>

                {/* Fresh Pineapple - Forecast (M2) */}
                <TableCell className="ded-tc" align="center" sx={{top:'96px!important'}}>
                    <div style={{ fontSize: "0.85em", fontWeight: "normal" }}>
                        ({getNextMonth(forecastHeader, 1)})
                    </div>
                </TableCell>

                {/* Fresh Pineapple - Forecast (M3) */}
                <TableCell className="ded-tc" align="center" sx={{top:'96px!important'}}>
                    <div style={{ fontSize: "0.85em", fontWeight: "normal" }}>
                        ({getNextMonth(forecastHeader, 2)})
                    </div>
                </TableCell>

                {/* Fresh Pineapple - Forecast (M4) */}
                <TableCell className="ded-tc" align="center" sx={{top:'96px!important'}}>
                    <div style={{ fontSize: "0.85em", fontWeight: "normal" }}>
                        ({getNextMonth(forecastHeader, 3)})
                    </div>
                </TableCell>

                {/* Fresh Pineapple - Forecast (M5) */}
                <TableCell className="ded-tc" align="center" sx={{top:'96px!important'}}>
                    <div style={{ fontSize: "0.85em", fontWeight: "normal" }}>
                        ({getNextMonth(forecastHeader, 4)})
                    </div>
                </TableCell>

                {/* Fresh Pineapple - Forecast (M6) */}
                <TableCell className="ded-tc" align="center" sx={{top:'96px!important'}}>
                    <div style={{ fontSize: "0.85em", fontWeight: "normal" }}>
                        ({getNextMonth(forecastHeader, 5)})
                    </div>
                </TableCell>

                {/* Fresh Pineapple - Forecast (Total Forecast) */}
                <TableCell className="ded-tc" align="center" sx={{top:'96px!important'}}>
                    <div style={{ fontSize: "0.85em", fontWeight: "normal" }}>
                        Total Forecast
                    </div>
                </TableCell>

                {/* Fresh Pineapple - Actual - Realisasi */}
                <TableCell className="ded-tc" align="center" sx={{top:'96px!important'}}>
                    <div style={{ fontSize: "0.85em", fontWeight: "normal" }}>
                        Realisasi
                    </div>
                </TableCell>

                {/* Fresh Pineapple - Actual - FC Berjalan */}
                <TableCell className="ded-tc" align="center" sx={{top:'96px!important'}}>
                    <div style={{ fontSize: "0.85em", fontWeight: "normal" }}>
                        FC Berjalan
                    </div>
                </TableCell>

                {/* Fresh Pineapple - Actual - % Realisasi */}
                <TableCell className="ded-tc" align="center" sx={{top:'96px!important'}}>
                    <div style={{ fontSize: "0.85em", fontWeight: "normal" }}>
                        % Realisasi
                    </div>
                </TableCell>

                {/* Banana - Forecast (M1) */}
                <TableCell className="ded-tc" align="center" sx={{top:'96px!important'}}>
                    <div style={{ fontSize: "0.85em", fontWeight: "normal" }}>
                        ({forecastHeader})
                    </div>
                </TableCell>

                {/* Banana - Forecast (M2) */}
                <TableCell className="ded-tc" align="center" sx={{top:'96px!important'}}>
                    <div style={{ fontSize: "0.85em", fontWeight: "normal" }}>
                        ({getNextMonth(forecastHeader, 1)})
                    </div>
                </TableCell>

                {/* Banana - Forecast (M3) */}
                <TableCell className="ded-tc" align="center" sx={{top:'96px!important'}}>
                    <div style={{ fontSize: "0.85em", fontWeight: "normal" }}>
                        ({getNextMonth(forecastHeader, 2)})
                    </div>
                </TableCell>

                {/* Banana - Forecast (M4) */}
                <TableCell className="ded-tc" align="center" sx={{top:'96px!important'}}>
                    <div style={{ fontSize: "0.85em", fontWeight: "normal" }}>
                        ({getNextMonth(forecastHeader, 3)})
                    </div>
                </TableCell>

                {/* Banana - Forecast (M5) */}
                <TableCell className="ded-tc" align="center" sx={{top:'96px!important'}}>
                    <div style={{ fontSize: "0.85em", fontWeight: "normal" }}>
                        ({getNextMonth(forecastHeader, 4)})
                    </div>
                </TableCell>

                {/* Banana - Forecast (M6) */}
                <TableCell className="ded-tc" align="center" sx={{top:'96px!important'}}>
                    <div style={{ fontSize: "0.85em", fontWeight: "normal" }}>
                        ({getNextMonth(forecastHeader, 5)})
                    </div>
                </TableCell>

                {/* Banana - Forecast (Total Forecast) */}
                <TableCell className="ded-tc" align="center" sx={{top:'96px!important'}}>
                    <div style={{ fontSize: "0.85em", fontWeight: "normal" }}>
                        Total Forecast
                    </div>
                </TableCell>

                {/* Banana - Actual - Realisasi */}
                <TableCell className="ded-tc" align="center" sx={{top:'96px!important'}}>
                    <div style={{ fontSize: "0.85em", fontWeight: "normal" }}>
                        Realisasi
                    </div>
                </TableCell>

                {/* Banana - Actual - FC Berjalan */}
                <TableCell className="ded-tc" align="center" sx={{top:'96px!important'}}>
                    <div style={{ fontSize: "0.85em", fontWeight: "normal" }}>
                        FC Berjalan
                    </div>
                </TableCell>

                {/* Banana - Actual - % Realisasi */}
                <TableCell className="ded-tc" align="center" sx={{top:'96px!important'}}>
                    <div style={{ fontSize: "0.85em", fontWeight: "normal" }}>
                        % Realisasi
                    </div>
                </TableCell>

                {/* Other Fresh Fruits - Forecast (M1) */}
                <TableCell className="ded-tc" align="center" sx={{top:'96px!important'}}>
                    <div style={{ fontSize: "0.85em", fontWeight: "normal" }}>
                        ({forecastHeader})
                    </div>
                </TableCell>

                {/* Other Fresh Fruits - Forecast (M2) */}
                <TableCell className="ded-tc" align="center" sx={{top:'96px!important'}}>
                    <div style={{ fontSize: "0.85em", fontWeight: "normal" }}>
                        ({getNextMonth(forecastHeader, 1)})
                    </div>
                </TableCell>

                {/* Other Fresh Fruits - Forecast (M3) */}
                <TableCell className="ded-tc" align="center" sx={{top:'96px!important'}}>
                    <div style={{ fontSize: "0.85em", fontWeight: "normal" }}>
                        ({getNextMonth(forecastHeader, 2)})
                    </div>
                </TableCell>

                {/* Other Fresh Fruits - Forecast (Total Forecast) */}
                <TableCell className="ded-tc" align="center" sx={{top:'96px!important'}}>
                    <div style={{ fontSize: "0.85em", fontWeight: "normal" }}>
                        Total Forecast
                    </div>
                </TableCell>

                {/* Other Fresh Fruits - Actual - Realisasi */}
                <TableCell className="ded-tc" align="center" sx={{top:'96px!important'}}>
                    <div style={{ fontSize: "0.85em", fontWeight: "normal" }}>
                        Realisasi
                    </div>
                </TableCell>

                {/* Other Fresh Fruits - Actual - FC Berjalan */}
                <TableCell className="ded-tc" align="center" sx={{top:'96px!important'}}>
                    <div style={{ fontSize: "0.85em", fontWeight: "normal" }}>
                        FC Berjalan
                    </div>
                </TableCell>

                {/* Other Fresh Fruits - Actual - % Realisasi */}
                <TableCell className="ded-tc" align="center" sx={{top:'96px!important'}}>
                    <div style={{ fontSize: "0.85em", fontWeight: "normal" }}>
                        % Realisasi
                    </div>
                </TableCell>
            </TableRow>
        </TableHead>
    );
}

export default RimenderStockTableHead;